const ShieldLink = () => {
  const wrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "70vh",
    background: "#b10d28", // Slomin’s dark blue
    color: "#fff",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  };

  const contentStyle = {
    maxWidth: "600px",
    padding: "20px",
  };

  const headingStyle = {
    fontSize: "42px",
    marginBottom: "16px",
  };

  const paragraphStyle = {
    fontSize: "18px",
    color: "rgba(255, 255, 255, 0.85)",
  };

  return (
    <section style={wrapperStyle}>
      <div style={contentStyle}>
        <h1 style={headingStyle}>Coming Soon</h1>
        <p style={paragraphStyle}>
          We're working on something new. Please check back soon.
        </p>
      </div>
    </section>
  );
};

export default ShieldLink;
